/* eslint-disable */
import React from "react";
import { isEmpty } from "lodash";
import ProductTabCategoryFilter from "@common/NewFilter/ProductTabFilter/CategoryFilter";
import ProductTabSizeFilter from "@common/NewFilter/ProductTabFilter/SizeFilter";

const getProductTabFilterPillContent = (props: any): any => {
  const {
    tree,
    genderName,
    categoryLabel,
    sizeFilterLabel,
    selectedCategories,
    selectedSizes
  } = props;
  const getGenderOptions = () => {
    if (!isEmpty(tree)) {
      return tree.genders.map((item: any) => ({
        label: item.name,
        value: item.id
      }));
    }
    return [];
  };

  const filterPillContent = [
    {
      children: (
        <ProductTabCategoryFilter
          selectedCategories={selectedCategories}
          genderOptions={getGenderOptions()}
          {...props}
        />
      ),
      isSelected: selectedCategories.length !== 0,
      gender: genderName,
      label: categoryLabel
    },
    {
      children: (
        <ProductTabSizeFilter
          selectedCategories={selectedCategories}
          genderOptions={getGenderOptions()}
          {...props}
        />
      ),
      isSelected: selectedSizes.length !== 0,
      label: sizeFilterLabel
    }
  ];

  return filterPillContent;
};

export default getProductTabFilterPillContent;
